/** @format */

import {IfElse, If} from 'frontier-utilities';
import {Input} from '@sttark/design-system';
import React, {useState} from 'react';
import SuperAgent from 'superagent';

// styles
import './create_company.scss';

const CreateCompany = ({onCreate}) => {
    const [name, setName] = useState('');
    const [pending, setPending] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = () => {
        setPending(true);
        SuperAgent.post('/account/companies/add/')
            .set('Accept', 'application/json')
            .send({name})
            .end((err, response) => {
                if (response.body) {
                    onCreate(response.body.company);
                    setError(null);
                    setName('');
                } else {
                    setError('Error creating company.');
                }
                setPending(false);
            });
    };

    const handleInputUpdate = value => {
        setName(value);
    };

    return (
        <div className="create-company-54mf">
            <h3 className="mb-4 mt-0 mx-0">Create Company Account</h3>
            <p>
                Company accounts are great for users who have multiple people ordering for their
                company. Once you create a company account, you can request other users to be part
                of your company. All orders will be merged and all users can see and reorder past
                orders.
            </p>
            <Input
                onChange={handleInputUpdate}
                placeholder="Company Name"
                required="required"
                disabled={pending}
                className="w-100"
                name="company"
                value={name}
                type="text"
            />

            <IfElse condition={pending}>
                <button className="btn btn--primary" disabled>
                    Creating Company...
                </button>
                <button onClick={handleSubmit} className="btn btn--primary">
                    Create Company
                </button>
            </IfElse>

            <If condition={error}>
                <aside className="alert alert-danger mt-4" role="alert">
                    {error}
                </aside>
            </If>
        </div>
    );
};

export default CreateCompany;
